import type { SxProps, Theme } from '@mui/material/styles';

/** Matches Zero / MUI default h4 page title sizing. */
export const PAGE_HEADER_TITLE_SX = {
  fontWeight: 600,
  color: 'text.primary',
  fontSize: '2.125rem',
  lineHeight: 1.235,
  letterSpacing: '0.00735em',
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_ACTION_BUTTON_SX = {
  borderRadius: '12px',
  px: 3,
  py: 1.5,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_ROW_SX = {
  borderTop: 1,
  borderColor: 'divider',
  pt: 2,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_ROW_COMPACT_SX = {
  borderTop: 1,
  borderColor: 'divider',
  pt: 1,
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_SX = {
  minHeight: 0,
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    minHeight: 44,
    px: 2,
  },
} as const satisfies SxProps<Theme>;

export const PAGE_HEADER_TABS_COMPACT_SX = {
  minHeight: 0,
  '& .MuiTab-root': { minHeight: 40 },
} as const satisfies SxProps<Theme>;
